import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { DesktopMailRecipientsComponent } from '@commons/core/mail/recipients/desktop-mail-recipients.component';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { module } from 'angular';

import { NotificationBrowserService } from '@contact/common-shared-feature';
import {
  AppConf,
  AppFacade,
  AuthService,
  ChosenCorrespondentMailComponent,
  BookingStmService,
  DeviceFacade,
  DisplayFacade,
  ElasticSearchService,
  EpticaInfoFacade,
  EpticaService,
  EpticaUserFacade,
  FooterComponent,
  FormFacade,
  HttpService,
  LayoutFacade,
  LoaderDeprecatedService,
  Logger,
  MailFacade,
  MailService,
  MessagingService,
  MetricDeprecatedService,
  MetricService,
  MomentService,
  NotificationCenterComponent,
  NotificationCenterFacade,
  PhoneValidationService,
  ProfileFacade,
  ProfileService,
  ProgressFacade,
  SessionFacade,
  StorageService,
  TileDispatcher,
  TileFacade,
  TileNavigationService,
  TileService,
  TimerFacade,
  TimerService,
  ToasterComponent,
  ToasterFacade,
  TranslateService,
} from '@contact/upgrade';

import { SessionDeprecatedService } from './auth/session-deprecated.service';
import { ToastDeprecatedService } from './notification/toast-deprecated.service';
import { HttpDeprecatedService } from './transport/http-deprecated.service';
import { AppExternalService } from './ui/app-external.service';
import { LayoutService } from './ui/layout.service';
import { ModalService } from './ui/modal/modal.service';
import { default as popinValidateName, PopinValidate } from './ui/popin/popin-validate/popin-validate.component';

export default module('contact.commons.core', [])
  // FACTORY
  .factory('appConf', downgradeInjectable(AppConf) as any)
  .factory('logger', downgradeInjectable(Logger) as any)
  .factory('tileNavigationService', downgradeInjectable(TileNavigationService) as any)
  .factory('tileService', downgradeInjectable(TileService) as any)
  .factory('externalApplications', downgradeInjectable(AppExternalService) as any)
  .factory('momentService', downgradeInjectable(MomentService) as any)
  .factory('phoneValidation', downgradeInjectable(PhoneValidationService) as any)
  .factory('httpDeprecated', downgradeInjectable(HttpDeprecatedService) as any)
  .factory('http', downgradeInjectable(HttpService) as any)
  .factory('elasticSearchService', downgradeInjectable(ElasticSearchService) as any)
  .factory('layoutService', downgradeInjectable(LayoutService) as any)
  .factory('loaderDeprecatedService', downgradeInjectable(LoaderDeprecatedService) as any)
  .factory('messaging', downgradeInjectable(MessagingService) as any)
  .factory('notificationBrowserService', downgradeInjectable(NotificationBrowserService) as any)
  .factory('toastDeprecatedService', downgradeInjectable(ToastDeprecatedService) as any)
  .factory('sessionDeprecatedService', downgradeInjectable(SessionDeprecatedService) as any)
  .factory('profileService', downgradeInjectable(ProfileService) as any)
  .factory('storage', downgradeInjectable(StorageService) as any)
  .factory('timerService', downgradeInjectable(TimerService) as any)
  .factory('modalService', downgradeInjectable(ModalService) as any)
  .factory('translateService', downgradeInjectable(TranslateService) as any)
  .factory('metric', downgradeInjectable(MetricService) as any)
  .factory('deprecatedMetric', downgradeInjectable(MetricDeprecatedService) as any)
  .service('mailService', downgradeInjectable(MailService as any))
  .service('epticaService', downgradeInjectable(EpticaService as any))
  .factory('authService', downgradeInjectable(AuthService) as any)
  .factory('bookingStmService', downgradeInjectable(BookingStmService) as any)
  // STORE
  .factory('ngrxStoreService', downgradeInjectable(Store) as any)
  .factory('ngrxActionService', downgradeInjectable(Actions) as any)
  .factory('tileFacade', downgradeInjectable(TileFacade) as any)
  .factory('tileDispatcher', downgradeInjectable(TileDispatcher) as any)
  .factory('deviceFacade', downgradeInjectable(DeviceFacade) as any)
  .factory('displayFacade', downgradeInjectable(DisplayFacade) as any)
  .factory('notificationCenterFacade', downgradeInjectable(NotificationCenterFacade) as any)
  .factory('profileFacade', downgradeInjectable(ProfileFacade) as any)
  .factory('sessionFacade', downgradeInjectable(SessionFacade) as any)
  .factory('appFacade', downgradeInjectable(AppFacade) as any)
  .factory('timerFacade', downgradeInjectable(TimerFacade) as any)
  .factory('toasterFacade', downgradeInjectable(ToasterFacade) as any)
  .factory('layoutFacade', downgradeInjectable(LayoutFacade) as any)
  .factory('mailFacade', downgradeInjectable(MailFacade) as any)
  .factory('formFacade', downgradeInjectable(FormFacade) as any)
  .factory('epticaInfoFacade', downgradeInjectable(EpticaInfoFacade) as any)
  .factory('epticaUserFacade', downgradeInjectable(EpticaUserFacade) as any)
  .factory('progressFacade', downgradeInjectable(ProgressFacade) as any)
  // COMPONENT
  .component(popinValidateName, new PopinValidate())
  // DOWNGRADED COMPONENT
  .directive('cngChosenCompositeMail', downgradeComponent({ component: ChosenCorrespondentMailComponent }) as angular.IDirectiveFactory)
  .directive('cngNotificationCenter', downgradeComponent({ component: NotificationCenterComponent }) as angular.IDirectiveFactory)
  .directive('cngToaster', downgradeComponent({ component: ToasterComponent }) as angular.IDirectiveFactory)
  .directive('cngFooter', downgradeComponent({ component: FooterComponent }) as angular.IDirectiveFactory)
  .directive('cngDesktopMailRecipients', downgradeComponent({ component: DesktopMailRecipientsComponent }) as angular.IDirectiveFactory)
  .name;
